import request from '@/utils/request'

// 当前用户信息：{ username, roles, gradeIds, subjectId }
export function me() {
  return request({ url: '/user/me', method: 'get' }).then(res => res.data)
}

// 用户管理：列表 / 新增 / 编辑 / 删除（后端仅 ADMIN 可访问）
export function listUsers() {
  return request.get('/user/list').then((res) => res.data)
}

// 听课评课模块用的执教教师/听课人/评课人候选（所有登录角色可访问，按同学科+年段重合返回）
export function listTeacherCandidates() {
  return request.get('/user/teachers').then((res) => res.data)
}

export function createUser(form) {
  return request.post('/user', form).then((res) => res.data)
}

export function updateUser(id, form) {
  return request.put(`/user/${id}`, form).then((res) => res.data)
}

export function deleteUser(id) {
  return request.delete(`/user/${id}`).then((res) => res.data)
}

// 批量逻辑删除用户，ids 为待删除用户 id 数组
export function batchDeleteUsers(ids) {
  return request.delete('/user/batch', { data: { ids } }).then((res) => res.data)
}

// 删除前业务引用检查配置（近 N 年；0=不限）：读取 / 保存（保存仅超管）
export function getUserDeleteConfig() {
  return request.get('/user/delete-config').then((res) => res.data)
}
export function saveUserDeleteConfig(form) {
  return request.put('/user/delete-config', form).then((res) => res.data)
}

// 下载批量导入模板（返回 Blob）
export function downloadTemplate() {
  return request({
    url: '/user/template',
    method: 'GET',
    responseType: 'blob'
  })
}

// 导出用户列表（按当前搜索条件 keyword 过滤，返回 Blob）
export function exportUsers(keyword) {
  return request({
    url: '/user/export',
    method: 'GET',
    params: { keyword },
    responseType: 'blob'
  })
}

// 上传 Excel 批量导入用户，返回逐行结果 List<UserImportRow>
export function importUsers(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/user/import', formData).then((res) => res.data)
}
